module.exports = __webpack_public_path__ + "img/screen_8.e7fd39f5.svg";